<template>
  <div>
    <h6 class="ms-1 mb-5 mt-2 text-gray-700">Фильтр для поиска</h6>
    <div class="p-5 rounded border bg-white">
      <div class="row">
        <div class="col-lg-4">
          <radio-field
            :model-value="filter.type"
            :value="1"
            placeholder="Договор"
            type="checkbox"
            id="filter.type.1"
            class="form-check-sm mb-5"
            @update:modelValue="updateFilterType"
          />
        </div>
        <div class="col-lg-4">
          <radio-field
            :model-value="filter.type"
            :value="2"
            placeholder="Резидент"
            type="checkbox"
            id="filter.type.2"
            class="form-check-sm mb-5"
            @update:modelValue="updateFilterType"
          />
        </div>
        <div class="col-lg-4">
          <radio-field
            :model-value="filter.type"
            :value="3"
            placeholder="Нерезидент"
            type="checkbox"
            id="filter.type.3"
            class="form-check-sm mb-5"
            @update:modelValue="updateFilterType"
          />
        </div>
      </div>
      <div class="py-5 mb-5 border-bottom border-top">
        <select-field
          :model-value="filter.product"
          :required="true"
          :disabled="true"
          id="filter.product"
          name="filter.product"
          :options="{ 1: 'ОГПО ВТС' }"
          placeholder="Продукт"
          @update:modelValue="updateFilterProduct"
        />
      </div>
      <form @submit.prevent="$emit('search')" id="search-policy">
        <input-field
          v-if="filter.type === 1"
          :model-value="form.contract"
          id="form.contract"
          name="form.contract"
          :required="true"
          placeholder="Номер договора"
          type="text"
          mb="5"
          @update:modelValue="updateFormField('contract', $event)"
          @input="updateUppercaseField('contract', $event.target.value)"
        />
        <input-mask-field
          v-if="filter.type === 2"
          :model-value="form.iin"
          id="form.iin"
          name="form.iin"
          :required="true"
          :mb="5"
          mask="############"
          placeholder="ИИН/БИН"
          type="text"
          @update:modelValue="updateFormField('iin', $event)"
        />
        <input-field
          v-if="filter.type === 3"
          :model-value="form.name"
          id="form.name"
          name="form.name"
          :required="true"
          placeholder="Имя"
          type="text"
          mb="5"
          @update:modelValue="updateFormField('name', $event)"
        />
        <input-field
          v-if="filter.type === 3"
          :model-value="form.surname"
          id="form.surname"
          name="form.surname"
          :required="true"
          placeholder="Фамилия"
          type="text"
          mb="5"
          @update:modelValue="updateFormField('surname', $event)"
        />
        <date-field
          v-if="filter.type === 3"
          :model-value="form.birthday"
          :required="true"
          id="client.birthday"
          name="client_birthday"
          placeholder="Дата рождения"
          mb="5"
          @update:modelValue="updateFormField('birthday', $event)"
        />
        <input-field
          v-if="filter.type === 3"
          :model-value="form.vehicle"
          id="form.vehicle"
          name="form.vehicle"
          :required="filter.type === 3"
          placeholder="Гос. номер"
          type="text"
          mb="5"
          @update:modelValue="updateFormField('vehicle', $event)"
          @input="updateUppercaseField('vehicle', $event.target.value)"
        />
        <div class="row">
          <div class="col-6">
            <button type="button" @click="$emit('clear')" class="btn btn-light-warning btn-sm w-100">Сбросить</button>
          </div>
          <div class="col-6">
            <button :disabled="!canSearch" type="submit" class="btn btn-primary btn-sm w-100">Поиск</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import InputMaskField from '@/components/Fields/InputMaskField'
import SelectField from '@/components/Fields/SelectField'
import InputField from '@/components/Fields/InputField'
import RadioField from '@/components/Fields/RadioButtonField'
import DateField from '@/components/Fields/DateField'

export default {
  name: 'PolicySearchPanel',
  components: {
    RadioField,
    DateField,
    InputField,
    InputMaskField,
    SelectField
  },
  props: {
    filter: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    canSearch: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:filter', 'update:form', 'search', 'clear'],
  methods: {
    updateFilterType(type) {
      this.$emit('update:filter', { ...this.filter, type })
    },
    updateFilterProduct(product) {
      this.$emit('update:filter', { ...this.filter, product })
    },
    updateFormField(field, value) {
      this.$emit('update:form', { ...this.form, [field]: value })
    },
    updateUppercaseField(field, value) {
      this.updateFormField(field, value.toUpperCase())
    }
  }
}
</script>
